<div class="sku-removal-wrapper"><mdicon name="trash-can" @click="proceed"></mdicon></div>